// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highLight--N0YPFIwj {\n  background: #ffeeed;\n  color: #fc5043;\n  white-space: pre;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highLight": "highLight--N0YPFIwj"
};
export default ___CSS_LOADER_EXPORT___;
